import { setSupabaseConfig } from '@joinomu/shared'

export const initializeEnvironment = () => {
  // Use Vite environment variables that are already working
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const environment = import.meta.env.VITE_ENVIRONMENT || 'local';
  
  console.log(`🌍 Initializing ${environment} environment`);
  console.log(`📍 Database: ${supabaseUrl}`);
  
  // Use existing setSupabaseConfig from shared package
  setSupabaseConfig({
    url: supabaseUrl,
    anonKey: supabaseAnonKey
  });
  
  return { environment, supabaseUrl, supabaseAnonKey };
};